import { render, staticRenderFns } from "./last-report-evaluation.vue?vue&type=template&id=bdd46ebe&"
import script from "./last-report-evaluation.vue?vue&type=script&lang=ts&"
export * from "./last-report-evaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports